import { getBuildTimestamp, getGameIDFromQuery, isMobile } from "@app/environmentsBasic";
import { urlSearchParams } from "@app/utils/urlSearchParams";
import { detectGPUName } from "@app/utils/detectGPU";
// WARNING: keep imports short as possible, to not blow up initial init.js bundle

export enum SentryGameStateTag {
	APP_INITIALIZATION = "APP_INITIALIZATION",
	APP_LOADING = "APP_LOADING",
	GAME_LOADING = "LOADING",
	LOADED = "LOADED",
	SPINNING = "SPINNING",
	WIN_PRESENTATION = "WIN_PRESENTATION",
	IDLE = "IDLE"
}

export type SentryTags = {
	"buildTimestamp": string;
	"Session ID": string;
	"Current game state": SentryGameStateTag;
	"Last web socket code"?: string;
	"gameID"?: string;
	"bf_env": string;
	"Is Mobile": boolean;
	"Game Mode": string;
	"browser_offline": boolean;
	"Original error message": string;
	"Was browser hidden": boolean
	"Bonus free spins"?: boolean;
	"GPU"?: string;
	"Is WebGL supported"?: boolean;
	"Is Browser Supported"?: boolean;
};

export const defaultTags = {
	buildTimestamp: new Date(getBuildTimestamp()).toLocaleString("en-GB", { timeZone: "UTC" }),
	gameID: getGameIDFromQuery(),
	"Session ID": urlSearchParams.get("sessionID") || "[not-set]",
	"Game Mode": urlSearchParams.get("gameMode") || "[not-set]",
	"Is Mobile": isMobile,
	"Current game state": SentryGameStateTag.APP_INITIALIZATION,
	// to see tag statistics on Sentry UI correctly, tags should be set to 'default' values at init
	"browser_offline": false,
	"Original error message": "[not-set]",
	"Was browser hidden": false,
	"bf_env": deleteAffixes(urlSearchParams.get("host")) || "[not-set]",
	"GPU": detectGPUName()
} as const satisfies SentryTags;

export function deleteAffixes(hostname: string | null = ""): string {
	if (!hostname) {
		return "";
	}

	return hostname.replace("gs-", "").replace(".beefee.co.uk/gameserver/", "");
}